import { render, staticRenderFns } from "./IdentityFields.vue?vue&type=template&id=ab2cdcaa&scoped=true"
import script from "./IdentityFields.vue?vue&type=script&lang=js"
export * from "./IdentityFields.vue?vue&type=script&lang=js"
import style0 from "./IdentityFields.vue?vue&type=style&index=0&id=ab2cdcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2cdcaa",
  null
  
)

export default component.exports